module.exports = __webpack_public_path__ + "img/logos.e6c67a5.png";